export default "__VITE_ASSET__BNv16tx8__"